import * as v from 'valibot';

const emailValidation = v.pipe(
    v.string(),
    v.trim(),
    v.nonEmpty('Please enter an email address'),
    v.email('Please enter a valid email address'),
);

export const LoginSchema = v.object({
    email: emailValidation,
    password: v.pipe(
        v.string(),
        v.trim(),
        v.nonEmpty('Please enter a password'),
    ),
});

export const SignUpSchema = v.object({
    email: emailValidation,
    password: v.pipe(
        v.string(),
        v.trim(),
        v.nonEmpty('Please enter a password'),
        v.minLength(8, 'Password must be at least 8 characters long'),
        v.maxLength(64, 'Password must not exceed 64 characters'),
        v.regex(/[a-z]/, 'Password must contain at least one lowercase letter'),
        v.regex(/[A-Z]/, 'Password must contain at least one uppercase letter'),
        v.regex(/\d/, 'Password must contain at least one number'),
        v.regex(
            /[^a-zA-Z0-9]/,
            'Password must contain at least one special character',
        ),
    ),
});

export type Login = v.InferOutput<typeof LoginSchema>;
export type SignUp = v.InferOutput<typeof SignUpSchema>;
